module.exports = __webpack_public_path__ + "media/chicken-road-jump_3.fd5b9b0d.mp3";